import { useData } from '@/hooks/useLocale'

/** One feature of the manual: what it does, numbered steps, and a tip if it has one. */
export default function GuideFeature({ feature }) {
  const { GUIDE } = useData()

  return (
    <article
      id={feature.id}
      data-spy
      className="flex flex-col gap-[18px] border-b border-[#f0f2f6] py-9"
    >
      <div className="flex flex-col gap-2">
        <span className="text-[13px] font-semibold text-subtle">{feature.n}</span>
        <h3 className="text-[26px] leading-[1.2] font-semibold tracking-[-0.02em] text-ink">
          {feature.title}
        </h3>
      </div>
      <p className="text-[17px]/[1.75] text-body">{feature.text}</p>

      <div className="mt-1 flex flex-col">
        <h4 className="pb-3.5 text-xs font-semibold tracking-[.14em] text-subtle uppercase">
          {GUIDE.stepsLabel}
        </h4>
        <ol>
          {feature.steps.map((step, i) => (
            <li key={step} className="group flex gap-4">
              {/* The step's number, joined to the next one by a line. */}
              <div className="flex shrink-0 flex-col items-center">
                <span className="grid size-7 place-items-center rounded-full bg-brand-tint text-[13px] font-bold text-brand">
                  {i + 1}
                </span>
                <span className="my-1 min-h-2.5 w-0.5 flex-1 bg-brand-tint group-last:bg-transparent" />
              </div>
              <span className="pt-[3px] pb-[18px] text-base/[1.65] text-[#1e2330]">
                {step}
              </span>
            </li>
          ))}
        </ol>
      </div>

      {feature.tip && (
        <p className="flex gap-3.5 rounded-2xl bg-[#f6f8fb] px-[18px] py-4 text-[15px]/[1.6] text-body">
          <span
            aria-hidden="true"
            className="grid size-6 shrink-0 place-items-center rounded-full bg-white text-[13px] font-bold text-brand inset-ring inset-ring-[#dfe3ea]"
          >
            i
          </span>
          <span>
            <span className="font-semibold text-ink">{GUIDE.tipLabel} </span>
            {feature.tip}
          </span>
        </p>
      )}
    </article>
  )
}
